import { hasPermission, PERM } from '../accessPermissions';

export function canDeliverOrder(userInfo) {
	return hasPermission(userInfo, PERM.ORDER_DELIVERY);
}

export function canAcceptOrder(userInfo) {
	return hasPermission(userInfo, PERM.ORDER_ACCEPT);
}

export function canReceiveOrderPayment(userInfo) {
	return hasPermission(userInfo, PERM.ORDER_PAYMENT_RECEIVE);
}
